import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Atlassian = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="Atlassian icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0H24V12C19.5 12 19.5 9 19.5 4.5C15 4.5 12 4.5 12 0ZM13.5 10.5C13.5 15 13.5 18 18 18V6H6C6 10.5 9 10.5 13.5 10.5ZM0 12C0 16.5 3 16.5 7.5 16.5C7.5 21 7.5 24 12 24V12H0Z"
    />
  </svg>
)
